package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.line.Line
import com.macrofocus.eflux.network.physical.left6
import com.macrofocus.eflux.network.risk.RiskComponent
import org.locationtech.jts.geom.Geometry
import org.molap.network.findComponents

open class RiskComponentsCapability : NetworkCapability {
    fun riskComponents(
        lines: Array<Line>?,
        riskThreshold: Double,
        riskBuffer: Double,
        riskMask: Int,
        isMoreCartographic: Boolean,
        isCartographicZoomed: Boolean
    ): List<RiskComponent> {
        val componentList = ArrayList<RiskComponent>()
        if (lines != null) {
            val components: List<Pair<Set<String>, Set<Line>>> = lines
                .toList()
                .filter { l -> l.riskMap?.let {
                    val probability = l.probability
                    if (probability != null && (it and riskMask != 0)) probability > riskThreshold / 100 else false } == true
                }
                .findComponents(
                    { n ->
                        val b = n.logicalBranchId
                        b.from.name.left6()
                    },
                    { n ->
                        val b = n.logicalBranchId
                        b.to.name.left6()
                    },
                    { l ->
                        l
                    }
                )
            for (component in components) {
                val geometries = component.second.map {
                    if (isCartographicZoomed) {
                        it.physicalGeometry?.buffer(riskBuffer / 200.0) as Geometry
                    } else if (isMoreCartographic) {
                        it.physicalGeometry?.buffer(riskBuffer / 100.0) as Geometry
                    } else {
                        it.logicalGeometry?.buffer(riskBuffer / 100.0) as Geometry
                    }
                }
                val riskComponent = RiskComponent(component.second, geometries)
                componentList.add(riskComponent)
            }
        }
        return componentList
    }
}